import StatusSuccess from '@assets/svg/status-success.svg';
import StatusError from '@assets/svg/status-error.svg';
import StatusNormal from '@assets/svg/status-normal.svg';

import { Container, Label, Icon } from './FormStatus.styles';

interface IFormStatus {
  status: 'success' | 'error' | 'none';
  label?: string;
}

const FormStatus = ({ status, label }: IFormStatus) => {
  return (
    <Container>
      {(() => {
        if (status === 'success') {
          return <Icon src={StatusSuccess} alt="success" />;
        }

        if (status === 'error') {
          return <Icon src={StatusError} alt="error" />;
        }

        return <Icon src={StatusNormal} alt="none" />;
      })()}
      <div style={{ width: 8 }} />
      <Label medium={status === 'error'}>{label}</Label>
    </Container>
  );
};

export { FormStatus };
